import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import TextFieldCompnent from "../../../components/textFieldComponent";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ButtonComponent from "../../../components/ButtonComponent";
import {
  getSettingsError,
  getSettingsLoading,
  getSettingsStatus,
  getSettingsSuccess,
  updateSetting,
  updateStatus,
} from "../../../features/settingSlice";
import SelectComponent from "../../../components/selectComponent";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyPrinter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state.printer;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { restaurantId } = useRestaurant();
  const status = useSelector(getSettingsStatus);
  const error = useSelector(getSettingsError);
  const loading = useSelector(getSettingsLoading);
  const success = useSelector(getSettingsSuccess);

  const schema = yup.object().shape({
    printMode: yup.boolean().required("Mode est requis"),
    printerIp: yup
      .string()
      .required("Ip est requis")
      .matches(
        /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/,
        "Entrez une adresse IP valide (ex: 192.168.1.100)"
      ),
  });

  const initialValues = {
    printMode: data.printMode || false,
    printerIp: data.printerIp || "",
  };

  const handleFormSubmit = (values) => {
    const formData = new FormData();
    formData.append("printMode", values.printMode);
    formData.append("printerIp", values.printerIp);
    dispatch(updateSetting({ formData, restaurantId }));
  };

  useEffect(() => {
    if (status === "updateSettingSuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/printer");
    } else if (status === "updateSettingError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header
        title={t("headers.editPrinter")}
        subtitle={t("headers.editPrinterSub")}
      />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={schema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => {
          const handleIpInput = (e) => {
            let value = e.target.value;
            value = value
              .split(".")
              .map((seg) => seg.slice(0, 3).replace(/[^0-9]/g, ""))
              .join(".")
              .replace(/\.{2,}/g, ".");
            e.target.value = value;
            handleChange(e);
          };
          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="16px"
                gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                }}
              >
                <SelectComponent
                  label={t("fields.printerMode")}
                  change={handleChange}
                  value={values.printMode}
                  name="printMode"
                  blur={handleBlur}
                  touched={touched.printMode}
                  error={errors.printMode}
                  gridColumn="span 3"
                  gridRow="1 / span 3"
                  required
                  items={[
                    { _id: true, name: t("fields.printAuto") },
                    { _id: false, name: t("fields.printLocal") },
                  ]}
                />
                {
                  values.printMode === false && (
                    <TextFieldCompnent
                      label={t("fields.printerIp")}
                      change={handleIpInput}
                      value={values.printerIp}
                      name="printerIp"
                      blur={handleBlur}
                      touched={touched.printerIp}
                      error={errors.printerIp}
                      colum="span 3"
                      row="4 / span 3"
                      placeholder="192.168.1.100"
                      required
                    />)
                }

              </Box>
              <ButtonComponent text={t("common.edit")} loading={loading} />
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default ModifyPrinter;
